import React, { useEffect, useState } from "react";
import { lifestyleApi } from "../apiService/api";
import { getGoqiiUserId } from "../apiService/timespam";

const ProfileHomeCardAdhd = () => {
  const goqiiUserId = getGoqiiUserId();
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    lifestyleApi.fetchDermaUser()
      .then((res) => {
        setName(res.data.userName || "");
        setAge(res.data.age || "");
        if (res.data.image) setImage(res.data.image);
      })
      .catch((err) => console.error("fetchDermaUser:", err));
  }, []);

  return (
    <a
      href={`https://goqii.com/app?fsn=71&fssn=0&fai={"friendId":"${goqiiUserId}"}`}
      className="profile-card-link"
    >
      <section className="profile-card">
        <img
          src={image || "https://appcdn.goqii.com/storeimg/user-icon.png"}
          className="profile-avatar"
          alt="user"
        />
        <div className="profile-info">
          <h1 className="profile-name">{name}</h1>
          <h2 className="profile-age">Age - {age} yrs</h2>
          <h3 className="profile-quote">The greatest Wealth is Health</h3>
        </div>
      </section>
    </a>
  );
};

export default ProfileHomeCardAdhd;
